import { xmlRpcEndpoint } from '@/services/Authentication';
import {xmlRpcClient} from './client';


// Create instance
const createIVRInstance = (data: any) => {
  const verbCreate = 'instancename.createinstance';
  const paramsCreate = [
    {
      Type: 'IVR',
      Instancename: 'HOTLINE_IVR_einstufig',
      Params: {
        GUI_TASTENZUORDNUNG: data && data.GUI_TASTENZUORDNUNG ? data.GUI_TASTENZUORDNUNG : {},
        GUI_RUFNUMMER: data && data.GUI_RUFNUMMER ? data.GUI_RUFNUMMER : '',
        GUI_SPRACHMENUE: data && data.GUI_SPRACHMENUE ? data.GUI_SPRACHMENUE : '',
        GUI_AUSWEICHRUFNUMMER: '300',
        GUI_ANZAHL_EINGABE_ZIFFERN: '2',
        GUI_WARTEZEIT: '15',
      },
    },
  ];
  return client(verbCreate, paramsCreate);
};

// Update instance
const updateIVRInstance = (data: any) => {
  const verbUpdate = 'instancename.modifyinstance';
  const paramsUpdate = [
    {
      Type: 'IVR',
      Instancename: 'HOTLINE_IVR_einstufig',
      Params: data,
    },
  ];
  return client(verbUpdate, paramsUpdate);
};

// Delete instance
const deleteIVRInstance = () => {
  const verbDelete = 'instancename.deleteinstance';
  const paramsDelete = [
    {
      Type: 'IVR',
      Instancename: 'HOTLINE_IVR_einstufig',
    },
  ];
  return client(verbDelete, paramsDelete);
};

// Get instance
const getIVRInstance = async () => {
  const verbGet = 'instancename.getinstance';
  const paramsGet = [
    {
      Type: 'IVR',
      Instancename: 'HOTLINE_IVR_einstufig',
    },
  ];
  return client(verbGet, paramsGet);
};

// Enable instance
const enableIVRInstance = async (state: boolean) => {
  const verbGet = state ? 'instancename.enableinstance' : 'instancename.disableinstance';
  const paramsGet = [
    {
      Type: 'IVR',
      Instancename: 'HOTLINE_IVR_einstufig',
    },
  ];
  return client(verbGet, paramsGet);
};

const client = async (verb: any, params: any) => {
    const retData = await xmlRpcClient(xmlRpcEndpoint(), verb, params);
    return retData;
  };


export { getIVRInstance, deleteIVRInstance, updateIVRInstance, createIVRInstance, enableIVRInstance };
